import React from "react";
import { Modal, Box } from "@mui/material";
import "./access-denied-modal.scss";

type AccessDeniedModalProps = {
  open: boolean;
  onClose: () => void;
};

export default function AccessDeniedModal({
  open,
  onClose,
}: AccessDeniedModalProps): JSX.Element {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="access-denied-modal"
      aria-labelledby="access-denied-title"
      aria-describedby="access-denied-description"
      slotProps={{
        backdrop: {
          sx: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
        },
      }}
    >
      <Box className="access-denied-content">
        <button className="access-denied-close" onClick={onClose}>
          ✕
        </button>
        <div className="access-denied-icon">🔒</div>
        {/* <h2 className="access-denied-title">Access Restricted</h2> */}
        <p className="access-denied-message">
          Current version rolled out to select SMEs, full launch coming soon.
          Check the "Watch It Work" video for an exclusive preview.
        </p>
        <button className="access-denied-button" onClick={onClose}>
          Got it
        </button>
      </Box>
    </Modal>
  );
}
